
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [formData, setFormData] = useState({
    year: '',
    make: '',
    model: '',
    condition: ''
  });
  const [contactForm, setContactForm] = useState({
    name: '',
    phone: '',
    year: '',
    make: '',
    model: '',
    message: ''
  });

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Add Schema.org JSON-LD
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#organization`,
          "name": "ScrapHawk Junk Car Removal Markham",
          "image": "https://public.readdy.ai/ai/img_res/1c17ccfd-84dd-42f2-9ea7-af10aae5aa31.png",
          "logo": "https://public.readdy.ai/ai/img_res/1c17ccfd-84dd-42f2-9ea7-af10aae5aa31.png",
          "url": import.meta.env.VITE_SITE_URL || 'https://example.com',
          "telephone": "647-584-9941",
          "email": "info@scraphawk.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Markham",
            "addressRegion": "ON",
            "addressCountry": "CA"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 43.8561,
            "longitude": -79.3370
          },
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
              "opens": "08:00",
              "closes": "20:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Sunday",
              "opens": "09:00",
              "closes": "18:00"
            }
          ],
          "priceRange": "$$",
          "areaServed": {
            "@type": "GeoCircle",
            "geoMidpoint": {
              "@type": "GeoCoordinates",
              "latitude": 43.8561,
              "longitude": -79.3370
            },
            "geoRadius": "50000"
          },
          "sameAs": [
            "https://www.facebook.com/scraphawk",
            "https://www.instagram.com/scraphawk"
          ]
        },
        {
          "@type": "WebSite",
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#website`,
          "url": import.meta.env.VITE_SITE_URL || 'https://example.com',
          "name": "ScrapHawk Junk Car Removal Markham",
          "description": "Markham's premier junk car removal service. Same-day pickup, instant cash payment, free towing.",
          "publisher": {
            "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#organization`
          }
        },
        {
          "@type": "Service",
          "serviceType": "Junk Car Removal",
          "provider": {
            "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#organization`
          },
          "areaServed": {
            "@type": "City",
            "name": "Markham",
            "containedIn": {
              "@type": "State",
              "name": "Ontario"
            }
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Junk Car Removal Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Same-Day Car Removal",
                  "description": "Fast, convenient pickup at your location in Markham and surrounding areas"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Instant Cash Payment",
                  "description": "Get paid on the spot when we pick up your vehicle"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Free Towing Service",
                  "description": "Absolutely no towing fees, we handle all logistics"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Any Make or Model",
                  "description": "We buy all makes and models in any condition"
                }
              }
            ]
          }
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    script.id = 'schema-org-jsonld';
    document.head.appendChild(script);

    return () => {
      const existingScript = document.getElementById('schema-org-jsonld');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  const handleQuickQuote = (e: React.FormEvent) => {
    e.preventDefault();
    window.location.href = `tel:647-584-9941`;
  };

  const handleContactSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    window.location.href = `tel:647-584-9941`;
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <header>
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-[rgba(26,26,26,0.95)] backdrop-blur-md shadow-lg' : 'bg-[rgba(26,26,26,0.95)] backdrop-blur-md'
        }`}>
          <div className="max-w-7xl mx-auto px-6 py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <h1>
                  <img 
                    src="https://public.readdy.ai/ai/img_res/1c17ccfd-84dd-42f2-9ea7-af10aae5aa31.png" 
                    alt="ScrapHawk Logo" 
                    className="h-12 w-auto"
                  />
                </h1>
                <span className="text-white font-bold text-xl">ScrapHawk</span>
              </div>
              
              <div className="hidden md:flex items-center gap-8">
                <a href="#home" className="text-white hover:text-[#FF6B35] transition-colors text-base font-medium whitespace-nowrap cursor-pointer">Home</a>
                <a href="#services" className="text-white hover:text-[#FF6B35] transition-colors text-base font-medium whitespace-nowrap cursor-pointer">Services</a>
                <a href="#quote" className="text-white hover:text-[#FF6B35] transition-colors text-base font-medium whitespace-nowrap cursor-pointer">Get a Quote</a>
                <a href="#about" className="text-white hover:text-[#FF6B35] transition-colors text-base font-medium whitespace-nowrap cursor-pointer">About Us</a>
                <a href="#contact" className="text-white hover:text-[#FF6B35] transition-colors text-base font-medium whitespace-nowrap cursor-pointer">Contact</a>
              </div>

              <div className="flex items-center gap-4">
                <a href="tel:647-584-9941" className="text-[#FF6B35] font-bold text-lg hidden lg:flex items-center gap-2 whitespace-nowrap cursor-pointer">
                  <i className="ri-phone-fill"></i>
                  647-584-9941
                </a>
                <a href="#quote" className="bg-[#FF6B35] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#ff5722] transition-all shadow-lg whitespace-nowrap cursor-pointer">
                  FREE QUOTE
                </a>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Hero Section */}
      <main>
        <section id="home" className="relative min-h-screen flex items-center pt-20">
          <div className="absolute inset-0">
            <img 
              src="https://public.readdy.ai/ai/img_res/a28f2220321dfebc4870b586009ab398.jpg" 
              alt="ScrapHawk Junk Car Removal Service"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
          </div>

          <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 w-full">
            <div className="grid lg:grid-cols-5 gap-12 items-center">
              <div className="lg:col-span-3">
                <div className="w-20 h-1 bg-[#FF6B35] mb-6"></div>
                <h2 className="text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
                  <strong>CASH FOR YOUR<br/>
                  JUNK CAR<br/>
                  IN MARKHAM</strong>
                </h2>
                <p className="text-xl text-gray-300 mb-10 leading-relaxed">
                  Same-day pickup • Top dollar paid • Free towing • No hidden fees
                </p>
                <div className="flex flex-wrap gap-4">
                  <a href="#quote" className="bg-[#FF6B35] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#ff5722] transition-all shadow-xl flex items-center gap-3 whitespace-nowrap cursor-pointer">
                    GET INSTANT QUOTE
                    <i className="ri-arrow-right-line text-xl"></i>
                  </a>
                  <a href="tel:647-584-9941" className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-black transition-all flex items-center gap-3 whitespace-nowrap cursor-pointer">
                    <i className="ri-phone-fill"></i>
                    CALL NOW: 647-584-9941
                  </a>
                </div>
              </div>

              <div className="lg:col-span-2">
                <div className="bg-white/95 backdrop-blur-sm rounded-3xl p-8 shadow-2xl">
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">Get Your Quote in 60 Seconds</h3>
                  <form onSubmit={handleQuickQuote} className="space-y-4">
                    <input
                      type="text"
                      name="year"
                      placeholder="Year"
                      value={formData.year}
                      onChange={(e) => setFormData({...formData, year: e.target.value})}
                      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-[#FF6B35] focus:outline-none text-sm"
                      required
                    />
                    <input
                      type="text"
                      name="make"
                      placeholder="Make"
                      value={formData.make}
                      onChange={(e) => setFormData({...formData, make: e.target.value})}
                      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-[#FF6B35] focus:outline-none text-sm"
                      required
                    />
                    <input
                      type="text"
                      name="model"
                      placeholder="Model"
                      value={formData.model}
                      onChange={(e) => setFormData({...formData, model: e.target.value})}
                      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-[#FF6B35] focus:outline-none text-sm"
                      required
                    />
                    <select
                      name="condition"
                      value={formData.condition}
                      onChange={(e) => setFormData({...formData, condition: e.target.value})}
                      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-[#FF6B35] focus:outline-none text-sm"
                      required
                    >
                      <option value="">Select Condition</option>
                      <option value="running">Running</option>
                      <option value="not-running">Not Running</option>
                      <option value="damaged">Damaged</option>
                      <option value="scrap">Scrap</option>
                    </select>
                    <button type="submit" className="w-full bg-[#FF6B35] text-white py-4 rounded-lg font-bold hover:bg-[#ff5722] transition-all shadow-lg whitespace-nowrap">
                      GET MY QUOTE NOW
                    </button>
                  </form>
                  <div className="flex items-center justify-center gap-6 mt-6 pt-6 border-t border-gray-200">
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <i className="ri-shield-check-fill text-[#FF6B35] text-lg"></i>
                      <span className="whitespace-nowrap">Licensed &amp; Insured</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <i className="ri-award-fill text-[#FF6B35] text-lg"></i>
                      <span className="whitespace-nowrap">BBB Accredited</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section id="services" className="py-24 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <div className="inline-block border-2 border-[#FF6B35] text-[#FF6B35] px-6 py-2 rounded-full font-semibold mb-6 whitespace-nowrap">
                OUR SERVICES
              </div>
              <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-4">
                We Buy Any Car,<br/>Any Condition
              </h2>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  icon: 'ri-truck-line',
                  title: 'Same-Day Removal',
                  description: 'We come to you within hours. Fast, convenient pickup at your location in Markham and surrounding areas.'
                },
                {
                  icon: 'ri-money-dollar-circle-line',
                  title: 'Instant Cash Payment',
                  description: 'Get paid on the spot. We bring cash and pay you immediately when we pick up your vehicle.'
                },
                {
                  icon: 'ri-service-line',
                  title: 'Free Towing Service',
                  description: 'Absolutely no towing fees. We handle all the logistics and transportation at zero cost to you.'
                },
                {
                  icon: 'ri-car-line',
                  title: 'Any Make or Model',
                  description: 'Cars, trucks, SUVs, vans - running or not. We buy all makes and models in any condition.'
                }
              ].map((service, index) => (
                <article key={index} className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group border-b-4 border-transparent hover:border-[#FF6B35]">
                  <div className="w-20 h-20 bg-[#FF6B35] rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                    <i className={`${service.icon} text-4xl text-white`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* About Section */}
        <section id="about" className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid lg:grid-cols-2 gap-16 items-center">
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20automotive%20service%20team%20with%20tow%20truck%20in%20front%20of%20modern%20facility%2C%20friendly%20staff%20members%20in%20uniform%20standing%20confidently%2C%20clean%20industrial%20setting%20with%20orange%20and%20black%20branding%20elements%2C%20corporate%20photography%20style%20showing%20trustworthy%20junk%20car%20removal%20business&width=800&height=900&seq=about-img-001&orientation=portrait" 
                  alt="ScrapHawk Professional Team"
                  className="w-full h-full object-cover rounded-3xl shadow-2xl"
                />
                <div className="absolute -top-6 -right-6 bg-[#FF6B35] text-white px-8 py-4 rounded-2xl shadow-xl">
                  <div className="text-4xl font-bold">10+</div>
                  <div className="text-sm font-semibold whitespace-nowrap">YEARS</div>
                </div>
              </div>

              <div>
                <div className="inline-block border-2 border-[#FF6B35] text-[#FF6B35] px-6 py-2 rounded-full font-semibold mb-6 whitespace-nowrap">
                  ABOUT SCRAPHAWK
                </div>
                <h2 className="text-5xl font-bold text-gray-900 mb-8 leading-tight">
                  Markham's Most Trusted Junk Car Buyers
                </h2>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  For over a decade, ScrapHawk has been Markham's premier junk car removal service. We've built our reputation on honesty, reliability, and exceptional customer service.
                </p>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                  Whether your car is old, damaged, or simply unwanted, we offer top dollar and make the entire process hassle-free. Our team of professionals ensures a smooth transaction from quote to pickup.
                </p>

                <div className="space-y-4 mb-10">
                  {[
                    'Licensed and insured professionals',
                    'Eco-friendly recycling practices',
                    'Transparent pricing, no surprises',
                    'Serving Markham and surrounding areas'
                  ].map((item, index) => (
                    <div key={index} className="flex items-center gap-4">
                      <div className="w-8 h-8 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-white text-xl"></i>
                      </div>
                      <span className="text-gray-700 text-lg">{item}</span>
                    </div>
                  ))}
                </div>

                <a href="#contact" className="inline-flex items-center gap-3 border-2 border-[#FF6B35] text-[#FF6B35] px-8 py-4 rounded-lg font-bold hover:bg-[#FF6B35] hover:text-white transition-all whitespace-nowrap cursor-pointer">
                  LEARN MORE ABOUT US
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonial Section */}
        <section className="py-24 bg-[#1a1a1a]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid lg:grid-cols-5 gap-12 items-center">
              <div className="lg:col-span-2">
                <img 
                  src="https://readdy.ai/api/search-image?query=satisfied%20middle-aged%20customer%20smiling%20confidently%20in%20casual%20clothing%2C%20professional%20portrait%20photography%20with%20neutral%20clean%20background%2C%20natural%20lighting%20showing%20trustworthy%20person%20who%20sold%20their%20junk%20car%2C%20authentic%20testimonial%20photo%20style&width=600&height=800&seq=testimonial-001&orientation=portrait" 
                  alt="Happy Customer"
                  className="w-full h-auto rounded-2xl shadow-2xl"
                />
              </div>

              <div className="lg:col-span-3">
                <i className="ri-double-quotes-l text-[#FF6B35] text-8xl mb-6 block"></i>
                <p className="text-white text-3xl leading-relaxed mb-8">
                  ScrapHawk made selling my old Honda so easy. They came within 2 hours, paid cash on the spot, and towed it away for free. Highly recommend!
                </p>
                <div className="flex items-center gap-2 mb-4">
                  {[1,2,3,4,5].map((star) => (
                    <i key={star} className="ri-star-fill text-[#FF6B35] text-2xl"></i>
                  ))}
                </div>
                <div className="mb-8">
                  <div className="text-white text-xl font-bold">Michael Thompson</div>
                  <div className="text-gray-400">Markham Homeowner</div>
                </div>
                <a href="#contact" className="inline-flex items-center gap-3 bg-[#FF6B35]/20 border border-[#FF6B35] text-[#FF6B35] px-8 py-4 rounded-full font-bold hover:bg-[#FF6B35] hover:text-white transition-all whitespace-nowrap cursor-pointer">
                  READ MORE REVIEWS
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section id="quote" className="relative py-32">
          <div className="absolute inset-0">
            <img 
              src="https://readdy.ai/api/search-image?query=panoramic%20view%20of%20Markham%20Ontario%20cityscape%20with%20modern%20highway%20and%20urban%20skyline%20at%20golden%20hour%2C%20wide%20angle%20cinematic%20photography%20showing%20vibrant%20city%20with%20orange%20sunset%20lighting%2C%20professional%20architectural%20photography%20with%20dramatic%20sky%20and%20clean%20composition&width=1920&height=800&seq=cta-bg-001&orientation=landscape" 
              alt="Markham Cityscape"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
          </div>

          <div className="relative z-10 max-w-7xl mx-auto px-6">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
              <div>
                <h2 className="text-6xl lg:text-7xl font-bold text-white mb-6 lowercase">
                  ready to get cash?
                </h2>
              </div>

              <div className="text-center lg:text-right">
                <p className="text-white text-2xl mb-4">Call us now or fill out our quick form</p>
                <p className="text-white/90 text-xl mb-8">Get your quote in under 60 seconds</p>
                <a href="tel:647-584-9941" className="inline-flex items-center bg-white text-black px-10 py-5 rounded-full font-bold text-lg hover:scale-105 transition-all shadow-2xl gap-4 whitespace-nowrap cursor-pointer">
                  GET QUOTE NOW
                  <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center">
                    <i className="ri-arrow-right-line text-white text-xl"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid lg:grid-cols-2 gap-16">
              <div>
                <h2 className="text-5xl font-bold text-gray-900 mb-12">Get In Touch</h2>
                
                <div className="space-y-8">
                  <div className="flex items-start gap-6">
                    <div className="w-16 h-16 bg-[#FF6B35] rounded-2xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-fill text-white text-3xl"></i>
                    </div>
                    <div>
                      <a href="tel:647-584-9941" className="text-4xl font-bold text-gray-900 hover:text-[#FF6B35] transition-colors cursor-pointer">
                        647-584-9941
                      </a>
                      <p className="text-gray-600 mt-2">Available 7 days a week</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-6">
                    <div className="w-16 h-16 bg-[#FF6B35] rounded-2xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-white text-3xl"></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-3">Business Hours</h3>
                      <p className="text-gray-700 text-lg">Mon-Sat: 8AM - 8PM</p>
                      <p className="text-gray-700 text-lg">Sunday: 9AM - 6PM</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-6">
                    <div className="w-16 h-16 bg-[#FF6B35] rounded-2xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-fill text-white text-3xl"></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-3">Service Area</h3>
                      <p className="text-gray-700 text-lg">Markham &amp; 50km radius</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-6">
                    <div className="w-16 h-16 bg-[#FF6B35] rounded-2xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-fill text-white text-3xl"></i>
                    </div>
                    <div>
                      <a href="mailto:info@scraphawk.com" className="text-2xl font-bold text-gray-900 hover:text-[#FF6B35] transition-colors cursor-pointer">
                        info@scraphawk.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-3xl font-bold text-gray-900 mb-8">Quick Contact Form</h3>
                <form onSubmit={handleContactSubmit} className="space-y-6">
                  <div>
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name"
                      value={contactForm.name}
                      onChange={(e) => setContactForm({...contactForm, name: e.target.value})}
                      className="w-full px-6 py-4 border-2 border-gray-300 rounded-lg focus:border-[#FF6B35] focus:outline-none text-base"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone Number"
                      value={contactForm.phone}
                      onChange={(e) => setContactForm({...contactForm, phone: e.target.value})}
                      className="w-full px-6 py-4 border-2 border-gray-300 rounded-lg focus:border-[#FF6B35] focus:outline-none text-base"
                      required
                    />
                  </div>
                  <div className="grid grid-cols-3 gap-4">
                    <input
                      type="text"
                      name="year"
                      placeholder="Year"
                      value={contactForm.year}
                      onChange={(e) => setContactForm({...contactForm, year: e.target.value})}
                      className="w-full px-6 py-4 border-2 border-gray-300 rounded-lg focus:border-[#FF6B35] focus:outline-none text-base"
                      required
                    />
                    <input
                      type="text"
                      name="make"
                      placeholder="Make"
                      value={contactForm.make}
                      onChange={(e) => setContactForm({...contactForm, make: e.target.value})}
                      className="w-full px-6 py-4 border-2 border-gray-300 rounded-lg focus:border-[#FF6B35] focus:outline-none text-base"
                      required
                    />
                    <input
                      type="text"
                      name="model"
                      placeholder="Model"
                      value={contactForm.model}
                      onChange={(e) => setContactForm({...contactForm, model: e.target.value})}
                      className="w-full px-6 py-4 border-2 border-gray-300 rounded-lg focus:border-[#FF6B35] focus:outline-none text-base"
                      required
                    />
                  </div>
                  <div>
                    <textarea
                      name="message"
                      placeholder="Tell us about your vehicle..."
                      value={contactForm.message}
                      onChange={(e) => setContactForm({...contactForm, message: e.target.value})}
                      rows={5}
                      className="w-full px-6 py-4 border-2 border-gray-300 rounded-lg focus:border-[#FF6B35] focus:outline-none text-base resize-none"
                      required
                    ></textarea>
                  </div>
                  <button type="submit" className="w-full bg-[#FF6B35] text-white py-5 rounded-lg font-bold text-lg hover:bg-[#ff5722] transition-all shadow-lg whitespace-nowrap">
                    SEND MESSAGE
                  </button>
                  <p className="text-sm text-gray-500 text-center">
                    We respect your privacy and will never share your information
                  </p>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#1a1a1a] text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-12 pb-12 border-b border-gray-700">
            <div className="flex items-center gap-3 mb-6 lg:mb-0">
              <img 
                src="https://public.readdy.ai/ai/img_res/1c17ccfd-84dd-42f2-9ea7-af10aae5aa31.png" 
                alt="ScrapHawk Logo" 
                className="h-12 w-auto"
              />
              <span className="text-white font-bold text-2xl">ScrapHawk</span>
            </div>
            <p className="text-gray-400">Markham's premier junk car removal service since 2014</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            <div>
              <h4 className="text-white text-lg font-bold mb-6">Quick Links</h4>
              <nav className="space-y-3">
                <a href="#home" className="block text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">Home</a>
                <a href="#about" className="block text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">About Us</a>
                <a href="#services" className="block text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">Services</a>
                <a href="#contact" className="block text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">Contact</a>
              </nav>
            </div>

            <div>
              <h4 className="text-white text-lg font-bold mb-6">Services</h4>
              <div className="space-y-3">
                <p className="text-gray-400">Car Removal</p>
                <p className="text-gray-400">Cash for Cars</p>
                <p className="text-gray-400">Free Towing</p>
                <p className="text-gray-400">Scrap Recycling</p>
              </div>
            </div>

            <div>
              <h4 className="text-white text-lg font-bold mb-6">Contact</h4>
              <div className="space-y-3">
                <a href="tel:647-584-9941" className="block text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">647-584-9941</a>
                <a href="mailto:info@scraphawk.com" className="block text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">info@scraphawk.com</a>
                <p className="text-gray-400">Markham, ON</p>
                <p className="text-gray-400">Mon-Sun 8AM-8PM</p>
              </div>
            </div>

            <div>
              <h4 className="text-white text-xl font-bold mb-4">ScrapHawk © 2025</h4>
              <p className="text-gray-400 mb-6">All rights reserved</p>
              <div className="flex gap-4">
                <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors text-2xl cursor-pointer" rel="nofollow">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors text-2xl cursor-pointer" rel="nofollow">
                  <i className="ri-instagram-fill"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors text-2xl cursor-pointer" rel="nofollow">
                  <i className="ri-google-fill"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors text-2xl cursor-pointer" rel="nofollow">
                  <i className="ri-yelp-fill"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 items-center pt-12 border-t border-gray-700">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20orange%20and%20black%20tow%20truck%20with%20ScrapHawk%20branding%20parked%20in%20front%20of%20modern%20automotive%20facility%2C%20clean%20commercial%20vehicle%20photography%20showing%20reliable%20junk%20car%20removal%20service%2C%20high%20quality%20business%20photo%20with%20industrial%20setting&width=560&height=360&seq=footer-img-001&orientation=landscape" 
                alt="ScrapHawk Tow Truck"
                className="w-full h-48 object-cover rounded-2xl"
              />
            </div>

            <div className="text-center">
              <p className="text-white text-3xl font-bold leading-tight">
                Fast. Fair.<br/>Reliable.
              </p>
            </div>

            <div>
              <h4 className="text-white text-lg font-bold mb-4">Stay Updated</h4>
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-1 px-4 py-3 bg-transparent border-2 border-gray-600 rounded-lg focus:border-[#FF6B35] focus:outline-none text-sm text-white placeholder-gray-500"
                />
                <button className="bg-[#FF6B35] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#ff5722] transition-all flex items-center gap-2 whitespace-nowrap">
                  SUBSCRIBE
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="text-center mt-12 pt-8 border-t border-gray-700">
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF6B35] transition-colors text-sm cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
